const config: siteConfig = {  
  ENCRYPTION: false,
  ENCRYPTION_KEY:
    "a3cbe4d8f9a917cdd46799ad9809d034b3036b5cd14e67465f02448c0c478512",
API_URL: "http://127.0.0.1:8001",

};

export default config;
